import React, { ReactElement } from 'react';
import oauthLogoGithubSrc from '../../assets/newBrandDesign/oauth-logo-github.svg';
import { ButtonProps } from '../Common';
import OauthButton from './OauthButton';

const NewGithubButton = (props: ButtonProps): ReactElement => {
  return <OauthButton {...props} iconSrc={oauthLogoGithubSrc} />;
};

export default NewGithubButton;
